import { z } from 'zod'

import { ModelSchemaBase, zodDateString } from './base.schema'

export const TaskLabelSchema = z.object({
  ...ModelSchemaBase,
  name: z.string(),
  color: z.string(),
})
export const TaskLabelListSchema = z.array(TaskLabelSchema)
export type ITaskLabel = z.infer<typeof TaskLabelSchema>

export const TaskAssignmentSchema = z.object({
  id: z.number(),
  receive_updates: z.boolean(),
  user: z.number(),
})

const TaskSchemaBase = {
  ...ModelSchemaBase,
  name: z.string(),
  description: z.string().nullish(),
  group: z.number(),
  order: z.number(),
  due_date_reminder: z.string(),
  start_date: zodDateString.nullish(),
  due_date: zodDateString.nullish(),
  // status: z.string(),
  pipeline: z.number().nullish(),
  is_completed: z.boolean().nullish(),

  contact: z
    .object({
      id: z.number(),
      first_name: z.string(),
      last_name: z.string(),
      email: z.string(),
      contact_type: z.string(),
      display: z.string(),
      edit_url: z.string().url(),
    })
    .nullish(),
  user_assignments: z.array(TaskAssignmentSchema),
}

export const TaskSchema = z.object({
  ...TaskSchemaBase,
  labels: z.array(
    z.object({ id: z.number(), name: z.string(), color: z.string() }),
  ),
})
export const TaskUpdateSchema = z.object({
  ...TaskSchemaBase,
  labels: z.object({ id: z.number() }).array(),
})

export type ITask = z.infer<typeof TaskSchema>
export type ITaskUpdate = z.infer<typeof TaskUpdateSchema>

export const TaskListSchema = z.array(TaskSchema)

export const TaskGroupSchema = z.object({
  ...ModelSchemaBase,
  name: z.string(),
  color: z.string(),
  order: z.number(),
  tasks: z.array(TaskSchema),
})

export const TaskGroupListSchema = z.array(TaskGroupSchema)

export type ITaskGroup = z.infer<typeof TaskGroupSchema>
